export default __webpack_public_path__ + "static/media/database_icon.b597ed40.svg";